import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/purchaseSlice";
import purchaseApis from "src/api/purchaseOrder";
import { constants } from "src/constants/common";
import { common } from "src/types";

function* GetPurchaseListSaga({
  payload,
}: ReturnType<typeof actions.getPurchaseListRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      purchaseApis.list,
      payload
    );
    yield put(actions.getPurchaseListSuccess(response));
  } catch (error) {
    yield put(
      actions.getPurchaseListError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* CreatePurchaseSaga({
  payload,
}: ReturnType<typeof actions.createPurchaseRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      purchaseApis.create,
      payload
    );
    yield put(actions.createPurchaseSuccess(response));
  } catch (error) {
    yield put(
      actions.createPurchaseError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* EditPurchaseSaga({
  payload,
}: ReturnType<typeof actions.editPurchaseRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      purchaseApis.update,
      payload.id,
      payload.data
    );
    yield put(actions.editPurchaseSuccess(response));
  } catch (error) {
    yield put(
      actions.editPurchaseError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* purchaseSaga() {
  yield all([
    takeEvery(actions.getPurchaseListRequest, GetPurchaseListSaga),
    takeEvery(actions.createPurchaseRequest, CreatePurchaseSaga),
    takeEvery(actions.editPurchaseRequest, EditPurchaseSaga),
  ]);
}
